<template>
  <v-alert
    border="top"
    color="orange"
    colored-border
    dense
    class="pa-0"
    :style="{ height: blockCardHeight + 'px'}"
  >
    <v-card-title class="d-flex flex-column justify-start align-start mt-2">
      <h3 class="subtitle-2 text-uppercase ml-2">
        <v-icon color="orange">
          mdi-wallet-outline
        </v-icon>
        Рахунок
      </h3>
    </v-card-title>
    <v-divider class="ml-6 mr-6" />
    <v-card-text class="ml-2 mb-0">
      <p class="mb-0">
        <b>Поточний баланс:</b><br>
        {{ `${balanceHours} годин` }}
      </p>
      <p
        v-if="!hasPositiveBalance"
        class="mb-0"
      >
        <b>Рекомендовано сплатити:</b><br>
        {{ `${recommendHours} годин ${recommendPackage}` }}
      </p>
    </v-card-text>
  </v-alert>
</template>

<script>
export default {
  props: {
    balance: {
      type: Object,
      default: () => {},
    },
    recommendedItem: {
      type: Object,
      default: () => {},
    },
    hasPositiveBalance: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    balanceHours() {
      return this.balance?.balanceHours || 0;
    },
    recommendHours() {
      return this.recommendedItem?.hours || 0;
    },
    recommendPackage() {
      return this.recommendedItem?.package?.title || "";
    },
    blockCardHeight() {
      return window.innerHeight * 0.27;
    },
    blockContentHeight(){
      return this.blockCardHeight - 120;
    },
  },
};
</script>